import React from 'react';
import Button from '../Button';
import Layout from '../Layout';
import Logo from '../Logo';
import * as styles from './HomeScreen.module.scss';

export interface HomeScreenProps {
  onStartClick: () => void;
}

const HomeScreen = ({ onStartClick }: HomeScreenProps): React.ReactElement => {
  return (
    <Layout largeSpikes>
      <div className={styles.container}>
        <div className={styles.contentContainer}>
          <p className={styles.intro}>
            Find out which superhero developer you are and share it with your friends!
          </p>
          <Logo className={styles.logo} />
          <Button className={styles.button} onClick={onStartClick}>
            Start quiz!
          </Button>
          {/* This element exists only to force preload the Slapstick font */}
          <span className={styles.preloadSlapstick}>&nbsp;</span>
        </div>
      </div>
    </Layout>
  );
};

export default HomeScreen;
